// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_vr5C_ {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0 auto; 
  padding: 20px 10px 0 10px;
  font-family: "Inter", sans-serif;
  max-height: calc(100vh - 50px);
  overflow-y: auto;
  box-sizing: border-box;
  -ms-overflow-style: none;
  scrollbar-width: none;
  background-color: var(--white-background);
  border-radius: 20px;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  -ms-border-radius: 20px;
  -o-border-radius: 20px;
}

.container_vr5C_::-webkit-scrollbar {
  display: none;
}
@media (width <= 768px) {
  .showInfoMobileBill_C_gvF {
    position: absolute;
    width: 100vw;
    max-width: 100vw;
    z-index: 3;
    background-color: var(--white-background);
  }
}
.header_a5pzF {
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  flex-wrap: wrap;
  gap: 4px;
}

.addNote_WIXAL {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .button_O_n25 {
    text-decoration: underline;
    font-weight: 500;
    cursor: pointer;
    width: fit-content;
  }

  .note_EoPhK {
    background-color: var(--_c2f2d3-background);
    border: 1px solid var(--_0000001d-border);
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-radius: 10px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
    .text_spwvN {
      min-height: 40px;
      height: fit-content;
      max-height: 100px;
      display: flex;
      align-items: center;
      overflow-y: scroll;
      scrollbar-width: none;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    span,
    input {
      background-color: transparent;
      font-family: "Inter", sans-serif;
      font-size: 13px;
    }
    input {
      background-color: var(--_9bd8b1fd-background);
      border: none;
    }
  }

}

.titleWrapper_zW4Ba {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  div {
    display: flex;
    align-items: center;
    gap: 8px;
    img {
      width: 16px;
      height: 22px;
    }
  }
  button {
    border: none;
    outline: none;
    background-color: transparent;
    text-decoration: underline;
    color: var(--_2-color);
    font-weight: bold;
  }
  button:disabled {
    color: var(--_b4-color);
  }
}

.dropdownContainer_ghVNC {
  display: flex;
  gap: 20px;
  justify-content: space-between;
}
.dropdownsLeft_XkB5G{
  display: flex;
  align-items: center;
  gap: 10px;
}

.chevronIcon_i20NS {
 height: 10px;
 width: 10px;
}

.dropdown_VenS8 {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  cursor: pointer;

}


.titleContent__UwQ7 {
  width: 100%;
}

.title_RirqL {
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  color: var(--_084437-color);
  width: 100%;
  border-radius: 8px;
  padding: 6px;
  border: none;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  background-color: var(--f4-background);
  outline: none;
}

.title_RirqL::placeholder {
  color: var(--_71717a-color);
}

.btnSectionsSelector_egMbc {
  background-color: var(--f9-background);
  display: flex;
  padding: 4px;
  border-radius: 12px;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  -ms-border-radius: 12px;
  -o-border-radius: 12px;
  button {
    flex: 1 1;
    padding: 12px;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    border: 1px solid transparent;
    background-color: transparent;
    color: var(--_b4-color);
  }
  .sectionSelect_O3uhc {
    background-color: var(--white-background);
    color: var(--_0d-color);
    border: 1px solid var(--_0000002b-border);
  }
}


.headerBillMobile_zlKHz {
  display: flex;
  justify-content: space-between;
  width: 100px;
  button {
    background-color: transparent;
    outline: none;
    border: none;
    color: var(--_292d32-color);
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; 
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .notesHeaderBillMobile_kN0VA {
    display: flex;
    align-items: center;
    gap: 0px;

    .note_EoPhK {
      display: flex;
      padding: 0px 5px;
      align-items: flex-start;
      gap: 3px;
      border-radius: 5px;
      background: var(--ef0-background);
    }

    button {
      color: var(--_929598-color);
      width: max-content;
      font-family: Inter;
      font-size: 8px;
      font-style: normal;
      font-weight: 500;
      line-height: 18px; 
    }
  }
}

.verticalOptionDots_DiJ6D {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
}

.secondContainer_Ygkbl{
  width: 100%;
  max-width: 800px;
}

.rowApprove_KXhgF{
  padding: 10px 0px;
  position:sticky;
  z-index: 2;
  top: -10px;
  background-color: var(--white-background);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.state_dBwMu{
  display: flex;
  align-items: center;
  justify-content: space-between;
  >div{
    display: flex;
    align-items: center;
    gap: 10px;
  }
}


.WindMagic_KatFD{
  fill: #8E8E93;
  height: 20px;
  width: 20px;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/InvoiceForm/InvoiceForm.module.css"],"names":[],"mappings":"AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,gCAAgC;EAChC,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,yCAAyC;EACzC,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;AACA;EACE;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,yCAAyC;EAC3C;AACF;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,2CAA2C;IAC3C,yCAAyC;IACzC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB;MACE,gBAAgB;MAChB,mBAAmB;MACnB,iBAAiB;MACjB,aAAa;MACb,mBAAmB;MACnB,kBAAkB;MAClB,qBAAqB;MACrB,wBAAwB;MACxB;QACE,aAAa;MACf;IACF;IACA;;MAEE,6BAA6B;MAC7B,gCAAgC;MAChC,eAAe;IACjB;IACA;MACE,6CAA6C;MAC7C,YAAY;IACd;EACF;;AAEF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;EACX;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR;MACE,WAAW;MACX,YAAY;IACd;EACF;EACA;IACE,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;;AAEjB;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB;IACE,SAAO;IACP,aAAa;IACb,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,6BAA6B;IAC7B,uBAAuB;EACzB;EACA;IACE,yCAAyC;IACzC,uBAAuB;IACvB,yCAAyC;EAC3C;AACF;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ;IACE,6BAA6B;IAC7B,aAAa;IACb,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;;IAER;MACE,aAAa;MACb,gBAAgB;MAChB,uBAAuB;MACvB,QAAQ;MACR,kBAAkB;MAClB,iCAAiC;IACnC;;IAEA;MACE,2BAA2B;MAC3B,kBAAkB;MAClB,kBAAkB;MAClB,cAAc;MACd,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;IACnB;EACF;AACF;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,UAAU;EACV,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;AACF;;;AAGA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;AACb","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap\");\n\n.container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  margin: 0 auto; \n  padding: 20px 10px 0 10px;\n  font-family: \"Inter\", sans-serif;\n  max-height: calc(100vh - 50px);\n  overflow-y: auto;\n  box-sizing: border-box;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  background-color: var(--white-background);\n  border-radius: 20px;\n  -webkit-border-radius: 20px;\n  -moz-border-radius: 20px;\n  -ms-border-radius: 20px;\n  -o-border-radius: 20px;\n}\n\n.container::-webkit-scrollbar {\n  display: none;\n}\n@media (width <= 768px) {\n  .showInfoMobileBill {\n    position: absolute;\n    width: 100vw;\n    max-width: 100vw;\n    z-index: 3;\n    background-color: var(--white-background);\n  }\n}\n.header {\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: 10px;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.addNote {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  .button {\n    text-decoration: underline;\n    font-weight: 500;\n    cursor: pointer;\n    width: fit-content;\n  }\n\n  .note {\n    background-color: var(--_c2f2d3-background);\n    border: 1px solid var(--_0000001d-border);\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    border-radius: 10px;\n    -webkit-border-radius: 10px;\n    -moz-border-radius: 10px;\n    -ms-border-radius: 10px;\n    -o-border-radius: 10px;\n    .text {\n      min-height: 40px;\n      height: fit-content;\n      max-height: 100px;\n      display: flex;\n      align-items: center;\n      overflow-y: scroll;\n      scrollbar-width: none;\n      -ms-overflow-style: none;\n      &::-webkit-scrollbar {\n        display: none;\n      }\n    }\n    span,\n    input {\n      background-color: transparent;\n      font-family: \"Inter\", sans-serif;\n      font-size: 13px;\n    }\n    input {\n      background-color: var(--_9bd8b1fd-background);\n      border: none;\n    }\n  }\n\n}\n\n.titleWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  width: 100%;\n  div {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    img {\n      width: 16px;\n      height: 22px;\n    }\n  }\n  button {\n    border: none;\n    outline: none;\n    background-color: transparent;\n    text-decoration: underline;\n    color: var(--_2-color);\n    font-weight: bold;\n  }\n  button:disabled {\n    color: var(--_b4-color);\n  }\n}\n\n.dropdownContainer {\n  display: flex;\n  gap: 20px;\n  justify-content: space-between;\n}\n.dropdownsLeft{\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.chevronIcon {\n height: 10px;\n width: 10px;\n}\n\n.dropdown {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  cursor: pointer;\n\n}\n\n\n.titleContent {\n  width: 100%;\n}\n\n.title {\n  font-size: 18px;\n  font-weight: 500;\n  margin: 0;\n  color: var(--_084437-color);\n  width: 100%;\n  border-radius: 8px;\n  padding: 6px;\n  border: none;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  background-color: var(--f4-background);\n  outline: none;\n}\n\n.title::placeholder {\n  color: var(--_71717a-color);\n}\n\n.btnSectionsSelector {\n  background-color: var(--f9-background);\n  display: flex;\n  padding: 4px;\n  border-radius: 12px;\n  -webkit-border-radius: 12px;\n  -moz-border-radius: 12px;\n  -ms-border-radius: 12px;\n  -o-border-radius: 12px;\n  button {\n    flex: 1;\n    padding: 12px;\n    border-radius: 8px;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    cursor: pointer;\n    font-weight: 600;\n    border: 1px solid transparent;\n    background-color: transparent;\n    color: var(--_b4-color);\n  }\n  .sectionSelect {\n    background-color: var(--white-background);\n    color: var(--_0d-color);\n    border: 1px solid var(--_0000002b-border);\n  }\n}\n\n\n.headerBillMobile {\n  display: flex;\n  justify-content: space-between;\n  width: 100px;\n  button {\n    background-color: transparent;\n    outline: none;\n    border: none;\n    color: var(--_292d32-color);\n    font-family: Inter;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px; \n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  .notesHeaderBillMobile {\n    display: flex;\n    align-items: center;\n    gap: 0px;\n\n    .note {\n      display: flex;\n      padding: 0px 5px;\n      align-items: flex-start;\n      gap: 3px;\n      border-radius: 5px;\n      background: var(--ef0-background);\n    }\n\n    button {\n      color: var(--_929598-color);\n      width: max-content;\n      font-family: Inter;\n      font-size: 8px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 18px; \n    }\n  }\n}\n\n.verticalOptionDots {\n  transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n}\n\n.secondContainer{\n  width: 100%;\n  max-width: 800px;\n}\n\n.rowApprove{\n  padding: 10px 0px;\n  position:sticky;\n  z-index: 2;\n  top: -10px;\n  background-color: var(--white-background);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n.state{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  >div{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n}\n\n\n.WindMagic{\n  fill: #8E8E93;\n  height: 20px;\n  width: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_vr5C_`,
	"showInfoMobileBill": `showInfoMobileBill_C_gvF`,
	"header": `header_a5pzF`,
	"addNote": `addNote_WIXAL`,
	"button": `button_O_n25`,
	"note": `note_EoPhK`,
	"text": `text_spwvN`,
	"titleWrapper": `titleWrapper_zW4Ba`,
	"dropdownContainer": `dropdownContainer_ghVNC`,
	"dropdownsLeft": `dropdownsLeft_XkB5G`,
	"chevronIcon": `chevronIcon_i20NS`,
	"dropdown": `dropdown_VenS8`,
	"titleContent": `titleContent__UwQ7`,
	"title": `title_RirqL`,
	"btnSectionsSelector": `btnSectionsSelector_egMbc`,
	"sectionSelect": `sectionSelect_O3uhc`,
	"headerBillMobile": `headerBillMobile_zlKHz`,
	"notesHeaderBillMobile": `notesHeaderBillMobile_kN0VA`,
	"verticalOptionDots": `verticalOptionDots_DiJ6D`,
	"secondContainer": `secondContainer_Ygkbl`,
	"rowApprove": `rowApprove_KXhgF`,
	"state": `state_dBwMu`,
	"WindMagic": `WindMagic_KatFD`
};
export default ___CSS_LOADER_EXPORT___;
